import { get } from '../../client';
import { shouldLogApiCalls } from '../../config';

export const getLogs = async (lines) => {
    if (shouldLogApiCalls) {
        console.log('Get logs attempt:');
    }

    return get(`/admin/log?lines=${lines}`);
}
